import { render, staticRenderFns } from "./CustomerDetailInformation.vue?vue&type=template&id=501ebef5"
import script from "./CustomerDetailInformation.vue?vue&type=script&lang=js"
export * from "./CustomerDetailInformation.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailInformation.vue?vue&type=style&index=0&id=501ebef5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports